/**
 * @generated SignedSource<<3e50efb6cd8a176d16d67026097fdb5d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type printAreaEditorDialogQuery$variables = Record<PropertyKey, never>;
export type printAreaEditorDialogQuery$data = {
  readonly printAreaTemplates: ReadonlyArray<{
    readonly height: number;
    readonly name: string;
    readonly templateID: number;
    readonly width: number;
  }>;
};
export type printAreaEditorDialogQuery = {
  response: printAreaEditorDialogQuery$data;
  variables: printAreaEditorDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "templateID",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "printAreaEditorDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PrintAreaTemplate",
        "kind": "LinkedField",
        "name": "printAreaTemplates",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "printAreaEditorDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PrintAreaTemplate",
        "kind": "LinkedField",
        "name": "printAreaTemplates",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "12cd9ac5e0dd214bea3b29b2312ac780",
    "id": null,
    "metadata": {},
    "name": "printAreaEditorDialogQuery",
    "operationKind": "query",
    "text": "query printAreaEditorDialogQuery {\n  printAreaTemplates {\n    templateID\n    name\n    width\n    height\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "021c0d0808ed2c7e185086922c370726";

export default node;
